// Test-IDs für E2E-Tests

// Diese Funktion fügt data-testid Attribute zu DOM-Elementen hinzu
export const applyTestIDs = () => {
  // Nur im Entwicklungs- oder Testmodus aktivieren
  if (process.env.NODE_ENV !== 'development' && process.env.NODE_ENV !== 'test') {
    return;
  }

  // ProjectsScreen
  document.querySelectorAll('.project-card').forEach((element, index) => {
    element.setAttribute('data-testid', `project-card-${index + 1}`);
  });

  // PhaseScreen
  document.querySelectorAll('.phase-card').forEach((element) => {
    const phaseId = element.getAttribute('data-phase-id') || '';
    element.setAttribute('data-testid', `phase-card-${phaseId}`);
  });

  // DocumentChecklist
  document.querySelectorAll('.document-item').forEach((element, index) => {
    element.setAttribute('data-testid', `document-item-${index + 1}`);
  });

  // CaptureModal
  const captureButton = document.querySelector('.capture-button');
  if (captureButton) captureButton.setAttribute('data-testid', 'capture-button');

  // SyncStatus
  const syncStatus = document.querySelector('.sync-status');
  if (syncStatus) {
    syncStatus.setAttribute('data-testid', 'sync-status');
    
    const pendingCount = syncStatus.querySelector('.pending-count');
    if (pendingCount) pendingCount.setAttribute('data-testid', 'pending-count');
    
    const manualSync = syncStatus.querySelector('.manual-sync');
    if (manualSync) manualSync.setAttribute('data-testid', 'manual-sync');
    
    const offlineIndicator = document.querySelector('.offline-indicator');
    if (offlineIndicator) offlineIndicator.setAttribute('data-testid', 'offline-indicator');
  }
};